import { Button } from "baseui/button";
import { ButtonGroup } from "baseui/button-group";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ROLE, SIZE } from "baseui/modal";
import { ProgressSteps, Step } from "baseui/progress-steps";
import { useState } from "react";
import { BsCurrencyExchange } from "react-icons/bs";
import { MdCo2 } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { CO2RateEditForm, CostRateEditForm, schemaCO2Rate, schemaCostRate } from "..";
import { CreateObjectInstanceCommand, useCreateObjectMutation } from "../../../../services/objects";
import { useReportMutationState } from "../../../../hooks/useReportMutationState";


const AddEnergyRateModal = (props: { resourceGroupId: string, isOpen: boolean, onClose: any }) => {
    const [current, setCurrent] = useState(0);
    const [type, setType] = useState(0);
    const [isValid, setIsValid] = useState(false);
    const [rate, setRate] = useState<any>();
    const [createObject, createObjectResult] = useCreateObjectMutation();
    useReportMutationState(createObjectResult, () => props.onClose());

    const handelSelectType = (_event, index) => { setType(index); setCurrent(1); setIsValid(false) }
    const handleClose = () => { setCurrent(0); props.onClose() }
    const handleBack = () => { setCurrent(current - 1); }
    const handleRateChanged = (newState: any) => { setRate(newState); setIsValid(newState.isValid) }

    const handleOkClick = () => {
        if (rate) {
            if (type === 0) {
                const cmd: CreateObjectInstanceCommand = {
                    name: rate.name,
                    description: "",
                    resourceGroupId: props.resourceGroupId,
                    schema: schemaCostRate,
                    properties: [{ key: 'ValuePerUnit', value: rate.valuePerUnit },
                    { key: 'CurrencyCode', value: rate.currencyCode }]
                }
                createObject(cmd);
            }
            else {
                const cmd: CreateObjectInstanceCommand = {
                    name: rate.name,
                    description: "",
                    resourceGroupId: props.resourceGroupId,
                    schema: schemaCO2Rate,
                    properties: [{ key: 'ValuePerUnit', value: rate.valuePerUnit }]
                }
                createObject(cmd);
            }
        }
    }

    return (
        <Modal
            onClose={handleClose}
            closeable
            isOpen={props.isOpen}
            animate
            autoFocus
            size={SIZE.default}
            role={ROLE.dialog}
        >
            <ModalHeader><FormattedMessage id="AddEnergyRateModal.header" defaultMessage="Add new energy rate"></FormattedMessage></ModalHeader>
            <ModalBody>
                <ProgressSteps current={current}>
                    <Step title={<FormattedMessage id="AddEnergyRateModal.selectRate" defaultMessage="Select Rate"></FormattedMessage>}>
                        <ButtonGroup mode={'radio'} size="large" selected={type} onClick={handelSelectType} >
                            <Button><BsCurrencyExchange size={'2em'}></BsCurrencyExchange></Button>
                            <Button><MdCo2 size={'2em'}></MdCo2></Button>
                        </ButtonGroup>
                    </Step>
                    <Step title={<FormattedMessage id="AddEnergyRateModal.rateProperties" defaultMessage="Rate Properties"></FormattedMessage>}>
                        {type === 0 && <CostRateEditForm onChange={handleRateChanged} {...rate}></CostRateEditForm>}
                        {type === 1 && <CO2RateEditForm onChange={handleRateChanged} {...rate}></CO2RateEditForm>}
                    </Step>
                </ProgressSteps>
            </ModalBody>
            <ModalFooter>
                {current > 0 && <ModalButton kind={'tertiary'} onClick={handleBack}>
                    <FormattedMessage id="prev" defaultMessage="prev"></FormattedMessage>
                </ModalButton>}
                <ModalButton kind={'tertiary'} onClick={handleClose}>
                    <FormattedMessage id="cancel" defaultMessage="Cancel"></FormattedMessage>
                </ModalButton>
                <ModalButton disabled={!isValid} onClick={handleOkClick} isLoading={createObjectResult.isLoading}>
                    <FormattedMessage id="ok" defaultMessage="Ok"></FormattedMessage>
                </ModalButton>
            </ModalFooter>
        </Modal>

    );
}

export default AddEnergyRateModal;